import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons'
import akshay from './akshay.jpg'
import anshul from './anshul.jpeg'
import raghav from './raghav.jpeg'

const AboutUs = () => {
  return (
    <div className='text-center bg-black text-white px-12 py-24'>
      <div className='text-5xl md:text-6xl font-bold mb-10 mt-14'>About Us</div>

      <p className='mb-6 md:text-xl font-light tracking-wide'>
        PopLink is a project by 3 individuals who deeply understand the problems in the advertising industry. Our
        mission is to make advertising a beautiful experience for all while making sure they also turn a profit.
      </p>
      <p className='mb-6 md:text-xl font-light tracking-wide'>
        Our core belief is that no one needs to forgo their privacy in order to experience and interact with the
        internet, and neither compromise on the quality of the experience.
      </p>
      <p className='mb-6 md:text-xl font-light tracking-wide'>
        PopLink will always keep the user in mind, and try to strive for the highest quality of interaction possible.
      </p>
      <p className='mb-6 md:text-xl font-light tracking-wide'>
        In our world, ads are considered the real content, and not something you are forced to click or engage with. Our
        deepest desire is for people to understand this, and join us in this mission to make the internet a safer and
        cleaner place.
      </p>

      <div className='text-2xl md:text-4xl font-bold mb-6 mt-14'>Core team</div>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-4 p-4 mb-6'>
        <div className='p-4 flex flex-col justify-center'>
          <img className='rounded-full m-auto mb-4' src={anshul} alt='Anshul Mohan' width={200} height={200} />
          <div>Anshul Mohan </div>
          <div className='mb-2'>CEO</div>
          <div className='flex items-center m-auto'>
            <a
              href='https://www.linkedin.com/in/anshulmohan27/'
              className='px-2 text-blue-500 hover:text-white'
              target='_blank'
              rel='noreferrer noopener'
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
          </div>
        </div>
        <div className='p-4 flex flex-col justify-center'>
          <img className='rounded-full m-auto mb-4' src={raghav} alt='Raghav Bhatia' width={200} height={200} />
          <div>Raghav Bhatia</div>
          <div className='mb-2'>CSA</div>
          <div className='flex items-center m-auto'>
            <a
              href='https://www.linkedin.com/in/raghav-bhatia-285417138/'
              className='px-2 text-blue-500 hover:text-white'
              target='_blank'
              rel='noreferrer noopener'
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
          </div>
        </div>
        <div className='p-4 flex flex-col justify-center'>
          <img className='rounded-full m-auto mb-4' src={akshay} alt='Akshay Kumar' width={200} height={200} />
          <div>Akshay Kumar</div>
          <div className='mb-2'>CTO</div>
          <div className='flex items-center m-auto'>
            <a
              href='https://www.linkedin.com/in/akshay-nm/'
              className='px-2 text-blue-500 hover:text-white'
              target='_blank'
              rel='noreferrer noopener'
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              href='https://github.com/akshay-nm'
              className='px-2 text-gray-500 hover:text-white'
              target='_blank'
              rel='noreferrer noopener'
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
          </div>
        </div>
      </div>
      <div className='md:text-2xl'>
        You can reach us at{' '}
        <a href='mailto:yourfriends@poplink.in'>
          <span className='text-gray-200 hover:text-white'>yourfriends@poplink.in</span>
        </a>
        .
      </div>
    </div>
  )
}

export default AboutUs
